<template>
  <div>
    <div v-if="!country" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <app-header :title="country.name" subtitle="Country">
        <button v-router-link="{name:'country-editor',query:{id:country.id}}" class="btn btn-large btn-primary">
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Country
        </button>
      </app-header>
      <b-container>
        <b-tabs>
          <b-tab title="Profile" fade show active class="mt-3">
            <b-card-group columns>
              <b-card no-body>
                <b-card-header>
                  Prices
                </b-card-header>
                <b-card-body>
                  <p>Print & Cut Price: {{ country.currency }} {{ country.printcutprice || 'Autoconverted from USD45' }}</p>
                  <p>Cut Only Price: {{ country.currency }} {{ country.cutonlyprice || 'Autoconverted from USD35' }}</p>
                </b-card-body>
              </b-card>
              <b-card no-body>
                <b-card-header>
                  Device Classifications
                </b-card-header>
                <b-card-body>
                  <b-button variant="light" @click="exportCSV()" class="mr-2">
                    Download CSV
                  </b-button>
                  <b-button variant="light" @click="importCSV()">
                    Upload CSV
                  </b-button>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-tab>
        </b-tabs>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import $csv from '@/services/csv';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      country: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.country = await $api.get(`/v1/internal/countries/${this.$route.params.id}`);
    },

    async exportCSV() {
      const rows = await $api.get(`/v1/internal/countries/${this.$route.params.id}/devicecategories`);
      $csv.export(rows, ['country', 'devicecategory_id', 'id', 'name', 'manufacturer_name'], `${this.$route.params.id}.devices.csv`);
    },

    async importCSV() {
      const deviceCategories = await $csv.import();
      await $api.put(`/v1/internal/countries/${this.$route.params.id}/devicecategories`, deviceCategories);
      alert('Updated OK'); // eslint-disable-line no-alert
    },
  },
};
</script>
